import React, { useMemo } from 'react';
import EChartCommon, { getAxisPointer } from '@op/components/EChartCommon';
import { chartAllColors } from '@/pages/opinion/constants';
import { getChartsShowCount } from '@/pages/opinion/utils';

type EChartsOptions = echarts.EChartsOption;
export default function EChart({
  tooltipFormatterFunc,
  seriesData,
  loading,
  height,
}: any) {
  // 设置图形配置
  const makeupOptions = () => {
    const xAxisData: Array<any> = [];
    const seriesDataArr: Array<any> = [];
    const legendData: Array<any> = [];

    seriesData.forEach(({ name, value }: any, index: number) => {
      seriesDataArr.push({
        value: value,
        name: name,
        itemStyle: {
          color: chartAllColors[index],
        },
      });
      legendData.push({
        name: name,
        icon: 'circle',
      });
      xAxisData.push(name);
    });
    const opts: EChartsOptions = {
      tooltip: {
        formatter: (param) => tooltipFormatterFunc(param),
      },
      grid: {
        bottom: 0,
        right: 0,
      },
      xAxis: {
        data: xAxisData,
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: (value) => {
            const data = getChartsShowCount(Math.abs(value), 1);
            return value >= 0 ? data : `-${data}`;
          },
        },
      },
      series: [
        {
          data: seriesDataArr,
          type: 'bar',
        },
      ],
    };

    return opts;
  };

  const options = useMemo(() => {
    return makeupOptions();
  }, [seriesData]);

  return (
    <EChartCommon
      options={options}
      loading={loading}
      optionsProps={{ type: 'bar', xAxisLabelInterval: 0 }}
      empty={seriesData.length === 0}
      height={height}
    ></EChartCommon>
  );
}
